import React from 'react';
import { Typography } from 'ui';
import { Color, TypeScales } from 'ui/primitives';
import PriceIcon from '../../../../../icons/keySpecs/Price.svg';
import FuelTypeIcon from '../../../../../icons/keySpecs/Fuel.svg';
import MileageIcon from '../../../../../icons/keySpecs/Mileage.svg';
import EngineIcon from '../../../../../icons/keySpecs/Engine.svg';
import TransmissionIcon from '../../../../../icons/keySpecs/Transmission.svg';
import SeatingCapacityIcon from '../../../../../icons/keySpecs/SeatingCapacity.svg';
import s from './SpecificationDetail.module.scss';
import { CarSpecificationType } from '../../../../../types';

export const SpecificationDetail = ({
  specification,
  price,
}: {
  specification: CarSpecificationType;
  price: number;
}) => (
  <div className={s.root}>
    <Typography
      label="Key specifications"
      variant={TypeScales.h2}
      renderAs="H2"
      className={s.heading}
    />
    <div className={s.container}>
      <div className={s.item}>
        <div className={s.icon}>
          <PriceIcon />
        </div>
        <div className={s.wrapper}>
          <Typography
            label="Price"
            variant={TypeScales.body_para_r}
            className={s.title}
            color={Color.text_caption}
          />
          <Typography
            label={price}
            variant={TypeScales.body_m}
            color={Color.text_subheading}
            className={s.description}
          />
        </div>
      </div>
      <div className={s.item}>
        <div className={s.icon}>
          <FuelTypeIcon />
        </div>
        <div className={s.wrapper}>
          <Typography
            label="Fuel type"
            variant={TypeScales.body_para_r}
            className={s.title}
            color={Color.text_caption}
          />
          <Typography
            label={specification?.fuelType?.replace('cng', 'CNG')}
            variant={TypeScales.body_m}
            color={Color.text_subheading}
            className={s.description}
          />
        </div>
      </div>
      <div className={s.item}>
        <div className={s.icon}>
          <MileageIcon />
        </div>
        <div className={s.wrapper}>
          <Typography
            label="Mileage"
            variant={TypeScales.body_para_r}
            className={s.title}
            color={Color.text_caption}
          />
          <Typography
            label={specification?.mileage}
            variant={TypeScales.body_m}
            color={Color.text_subheading}
            className={s.description}
          />
        </div>
      </div>
      <div className={s.item}>
        <div className={s.icon}>
          <EngineIcon />
        </div>
        <div className={s.wrapper}>
          <Typography
            label="Engine"
            variant={TypeScales.body_para_r}
            className={s.title}
            color={Color.text_caption}
          />
          <Typography
            label={specification?.engine?.toUpperCase()}
            variant={TypeScales.body_m}
            color={Color.text_subheading}
            className={s.description}
          />
        </div>
      </div>
      <div className={s.item}>
        <div className={s.icon}>
          <SeatingCapacityIcon />
        </div>
        <div className={s.wrapper}>
          <Typography
            label="Seating capacity"
            variant={TypeScales.body_para_r}
            className={s.title}
            color={Color.text_caption}
          />
          <Typography
            label={`${specification?.seatingCapacity} seater`}
            variant={TypeScales.body_m}
            color={Color.text_subheading}
            className={s.description}
          />
        </div>
      </div>
      <div className={s.item}>
        <div className={s.icon}>
          <TransmissionIcon />
        </div>
        <div className={s.wrapper}>
          <Typography
            label="Transmission"
            variant={TypeScales.body_para_r}
            className={s.title}
            color={Color.text_caption}
          />
          <Typography
            label={specification?.transmission}
            variant={TypeScales.body_m}
            color={Color.text_subheading}
            className={s.description}
          />
        </div>
      </div>
    </div>
  </div>
);
